module.exports = __webpack_public_path__ + "img/worksbot_img19112513.2a9d4022.jpg";